import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['%'] as const;

const validator = AbstractMeasurement.nomMax.extend({
    unit: z.enum(units).default('%'),
});

export const Efficiency = {
    validator,
    units,
};
